import '../assets/css/colors.css'
import '../assets/css/topMenu.css'
import '../assets/css/fonts.css'
import '../assets/css/scrollbar.css'
import GlobalVar from './subComponents/GlobalVar'
import {useLocation, useNavigate} from 'react-router-dom';
import { useEffect, useState } from 'react';

const DropDownLateral = ({item, navigate, location})=>{

    const [showBtns, setShowBtns] = useState(false)
    return <div className={`dropdown ${location.split("/")[1] === item.active ? 'activeMenu' : ''}`} onClick={()=>setShowBtns(!showBtns)}>
        <span>{item.title}</span>
        {showBtns ? <div className="subMenuDrop">
            <div className="divisorDrop"></div>
            {item.subMenus.map((val)=> <div  key={val.title+"topMenu"}
            className={`subBtns ${location === val.route ? 'activeMenu' : ''}`}
            onClick={()=>navigate(val.route)}>{val.title}</div>)}
        </div> : <></>}
    </div>
}

export default function TopMenu({ativaResp,showStyle, sacolaRef, children, stateInfo}){

    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario'));  // ObjetoUsuario 
    const cargo = () => usuario?.usu_tipo == 4 ? 'EXPEDICAO' : usuario.fornInfo?.for_cod ? 'FORNECEDOR' : 'VENDEDORA'
    const navigate = useNavigate();

    const [showLateralMenu, setShowLateralMenu] = useState('inicial')

    

    const location = useLocation().pathname;

    useEffect(() => {
        if (showStyle) {
            
          // Importa dinamicamente quando necessário
        //   import('../../assets/css/estilo.css');
        }
      }, [showStyle]);

      useEffect(() => {
        console.log("CARRENGANDO")
        if(!GlobalVar.getSessionStorage('usuario')){
            navigate("/")
        }
      }, []);

        if (!usuario) {
            return <div>Carregando...</div>;
          }
    
    return <>
    
        <div className='topMenu' style={{position: 'relative', height: ativaResp ? '8vh' : '7vh', overflowX: 'hidden'}}></div>
        <div className={`topMenu  ${showLateralMenu === 'inicial' ? 'overlayMenuInicial' : showLateralMenu ? "mostraMenuoverlay" : "escondeMenuoverlay"}`}>
            <div className="leftMenu">
                <div className='logo'></div>
                {/* <div className="clientInfo">
                <div className='nome'>NOMEUSU</div>
                </div> */}
            </div>
            {sacolaRef ? <div className="sacola" style={stateInfo ? {'--qtde': `"${stateInfo.quantidadeTotalSacola}"`} : {'--qtde': `"0"`}}  onClick={()=>{sacolaRef.current.setShowLateralSacola(true)}}></div> : <></>}
            <div className="sideMenuBtn" onClick={()=>setShowLateralMenu(showLateralMenu === 'inicial' ? true : !showLateralMenu)}></div>
        </div>
        <div className={`lateralMenu  ${showLateralMenu === 'inicial' ? 'lateralMenuInicial' : showLateralMenu ? "mostraMenuLateral" : "escondeMenuLateral"}`}>

            <div className='menuCloseBtn' onClick={()=>setShowLateralMenu(false)}></div>
            <div className='logo'></div>
            <div className="clientInfo">
            <div className='nome'>{usuario.nomeusu}</div>

            <div className='lateralMenulineBar'></div>

            <div className="lateralMenuRedirect">
                <div className={`unique ${location.split("/")[1] === "HomePage" ? 'activeMenu' : ''}`} onClick={()=>navigate("/HomePage")}>Pagina Inicial</div>           

                    {cargo() == 'FORNECEDOR' ? <>
                        <div className={`dropdown ${location.split("/")[1] === 'CorteDePecasFornecedor' ? 'activeMenu' : ''}`} onClick={()=>navigate('/CorteDePecasFornecedor')}>
                            <span>Corte Total De Peças</span>    
                        </div>
                    </>: <></>}
                    
                    {cargo() == 'VENDEDORA' ? <>
                    <div className={`dropdown ${location.split("/")[1] === 'TirarPedido' ? 'activeMenu' : ''}`} onClick={()=>navigate('/TirarPedido')}>
                        <span>Tirar Pedido</span>    
                    </div> 
                    </>: <></>}
                    <div className={`dropdown ${location.split("/")[1] === 'ConsultarPedidosVendedoras' ? 'activeMenu' : ''}`} onClick={()=>navigate('/ConsultarPedidosVendedoras')}>
                        <span>Consultar Pedidos</span>    
                    </div>
            </div>
            
            <div className="lateralMenuSair" onClick={()=>navigate("/Logar")}>Sair</div>
            

            </div>
        </div>
        {children}
        <div className={`overlaytopMenu  ${showLateralMenu === 'inicial' ? 'overlayMenuInicial' : showLateralMenu ? "mostraMenuoverlay" : "escondeMenuoverlay"}`} ></div>
        </>
}